import React, { useEffect, useState } from 'react'

// import OrthopedicsSection from '../site/pages/cancer/OrthopedicsSection';
import WhyChooseSection from '../site/components/WhyChooseSection/WhyChooseSection';
import OurServicesSection from '../site/components/OurServicesSection/OurServicesSection';
import WhatsetsApartSection from '../site/components/WhatSetsApartSection/WhatsetsApartSection';
import WhenConsultSection from '../site/components/WhenConsultSection/WhenConsultSection';

import kneeImage from "../assets/images/oncology-banner.webp";

import Icon1 from '../site/assets/images/Patient-CenteredCare.svg';
import Icon2 from '../site/assets/images/AdvancedDiagnosticTechnology.svg';
import Icon3 from '../assets/images/Robotic-Assisted-Precision.svg';
import Icon4 from '../assets/images/ComprehensiveRehabilitation.svg';
import Icon5 from '../assets/images/AffordableOrthopedicIcon.svg';

import ConditionIcon1 from '../assets/images/Breast-Cancer-icon.svg';
import ConditionIcon2 from '../assets/images/Lung-Cancer.svg';
import ConditionIcon3 from '../assets/images/Colorectal-Cancer.svg';
import ConditionIcon4 from '../assets/images/Oral-and-Head-Neck-Cancer.svg';
import ConditionIcon5 from '../assets/images/Gastric-Cancer.svg';
import ConditionIcon6 from '../assets/images/Gynecological-Cancers.svg';
import ConditionIcon7 from '../assets/images/Prostate-Cancer.svg';
import ConditionIcon8 from '../assets/images/Blood-Cancers.svg';
import ConditionIcon9 from '../assets/images/Liver-and-Pancreatic-Cancer.svg';
import ConditionIcon10 from '../assets/images/Bone-and-Soft-Tissue-Sarcomas.svg';
import ConditionIcon11 from '../assets/images/Thyroid-Cancer.svg';
import ConditionIcon12 from '../assets/images/Skin-Cancer-icon.svg';
import ConditionsTreatSection from '../site/components/ConditionsTreatSection/ConditionsTreatSection';
import FaqSection from '../site/components/FaqSection/FaqSection';
import PatientSuccessStories from '../site/components/PatientsSuccessStorySection/PatientSuccessStories';
import LokmanyaNetwork from '../site/components/LokmanyaNetworkSection/LokmanyaNetwork';
import { CommonBanner } from '../site/components';
import Head from 'next/head';
import MeetOurExpertSpeciality from '@/site/components/MeetOurExpertSpeciality';
import { useRouter } from 'next/router';
import { getSpecialityDoctors } from '@/ApiActions/CommonApi';


const WhyChooseData = {
  title: "Why Choose Lokmanya Hospitals for Oncology Care",
  items: [
    {
      title: 'Comprehensive Cancer Care',
      description: 'We offer a full spectrum of treatments for cancer , from diagnosis and staging to surgery, chemotherapy, radiation therapy, and post-treatment rehabilitation, all under one roof.',
      image: "/images/specialities-images/JNK/comprehensive-cancer-care.webp",
    },
    {
      title: 'Expert Team of Oncologists',
      description: 'Our surgical oncologists, medical oncologists, and radiation oncologists bring extensive experience in diagnosing and treating a wide range of cancers, ensuring every patient receives the most precise, evidence-based care available.',
      image: "/images/specialities-images/JNK/expert-team-of-oncologists.webp",
    },
    // {
    //   title: 'State-of-the-Art Infrastructure',
    //   description: 'We are equipped with cutting-edge medical technologies, including robotic-assisted surgeries, to provide precise and effective joint replacement procedures.',
    //   image: Image3,
    // },
    {
      title: 'Personalized Treatment Plans',
      description: "We believe in tailoring care to each individual. After a thorough diagnostic workup, our specialists design a customized treatment plan , whether surgical, non-surgical, or a combined approach , that aligns with your specific cancer type and stage.",
      image: "/images/specialities-images/JNK/personalized-treatment-plans.webp",
    },

    {
      title: 'Affordable and Accessible',
      description: 'At Lokmanya Hospitals, we are committed to making high-quality cancer treatment accessible to all patients, offering cost-effective solutions with cashless insurance and EMI options, without any compromise on clinical excellence.',
      image: "/images/specialities-images/JNK/affordable-and-accessible.webp",
    },
    {
      title: 'Unmatched Procedural Expertise',
      description: 'With an impressive record of thousands of successful oncology procedures , including tumor resection surgery, chemotherapy administration, radiation therapy, and minimally invasive cancer surgery , our specialists deliver precision, safety, and superior outcomes for every patient.',
      image: "/images/specialities-images/JNK/unmatched-procedural-expertise.webp",
    },
  ]
};

const serviceData = {
  title: "Our Oncology Services",
  items: [
    {
      title: "Surgical Oncology",
      description: " Precise, minimally invasive and open surgical procedures to remove tumors while preserving surrounding healthy tissue and organ function wherever possible.",
      imageUrl: "/images/specialities-images/JNK/surgical-oncology.webp",
    },
    {
      title: "Medical Oncology & Chemotherapy",
      description: "Personalized chemotherapy protocols administered under expert supervision, designed to target cancer cells while managing side effects effectively.",
      imageUrl: "/images/specialities-images/JNK/medical-oncology.webp",
    },
    {
      title: "Radiation Oncology",
      description: "Advanced radiation therapy techniques that precisely target tumors, minimizing damage to healthy surrounding tissue for better treatment outcomes.",
      imageUrl: "/images/specialities-images/JNK/radiation-oncology.webp",
    },
    {
      title: "Cancer Screening & Early Detection",
      description: "Comprehensive screening programs for breast, cervical, oral, colorectal, and other common cancers to enable early diagnosis and better prognosis.",
      imageUrl: "/images/specialities-images/JNK/cancer-screening-early-detection.webp",
    },
    {
      title: "Biopsy & Diagnostic Services",
      description: "Accurate tissue sampling and histopathological evaluation to confirm diagnosis, determine cancer type, and guide treatment planning.",
      imageUrl: "/images/specialities-images/JNK/biopsy-diagnostic-services.webp",
    },
    {
      title: "Palliative & Supportive Care",
      description: "Compassionate care focused on symptom relief, pain management, and quality of life for patients undergoing or recovering from cancer treatment.",
      imageUrl: "/images/specialities-images/JNK/palliative-supportive-care.webp",
    },
    {
      title: "Targeted Therapy & Immunotherapy",
      description: "Modern treatment options that target specific cancer cell mechanisms or boost the body's immune response, offering advanced alternatives to conventional chemotherapy.",
      imageUrl: "/images/specialities-images/JNK/targeted-therapy-immunotherapy.webp",
    },
    {
      title: "Post-Treatment Rehabilitation & Follow-Up",
      description: "Structured follow-up care including regular monitoring, nutritional counselling, and rehabilitation support to aid long-term recovery and prevent recurrence.",
      imageUrl: "/images/specialities-images/JNK/post-treatment-rehabilitation-Follow-Up.webp",
    }
  ]
};

const whatsetsApartdata = {
  title: "Oncology care at Lokmanya Hospitals - What Sets Us Apart?",
  items: [
    {
      title: "Patient-Centered Cancer Care",
      description: "Every patient receives a personalised consultation, accurate diagnostic evaluation, and a treatment plan designed exclusively around their cancer type, stage, and personal goals.",
      icon: Icon1,
    },
    {
      title: "Advanced Diagnostic Technology",
      description: "Early and accurate diagnosis drives effective treatment. Our imaging and laboratory diagnostics help pinpoint tumor location, size, and staging with precision.",
      icon: Icon2,
    },
    {
      title: "Multidisciplinary Treatment Approach",
      description: "Our surgical, medical, and radiation oncologists collaborate closely, ensuring coordinated, well-rounded care at every stage of treatment.",
      icon: Icon3,
    },
    {
      title: "Minimally Invasive Techniques",
      description: "We prioritize minimally invasive cancer surgery wherever clinically appropriate, reducing pain, scarring, and recovery time while preserving quality of life.",
      icon: Icon4,
    },
    {
      title: "Comprehensive Post-Treatment Rehabilitation",
      description: "Recovery is as important as treatment. Our post-procedure care includes nutritional guidance, physiotherapy support, and regular follow-up to support long-term wellness.",
      icon: Icon5,
    },
    {
      title: "Affordable Cancer Treatment in Pune",
      description: "We ensure world-class oncology care remains within reach for all patients, with transparent pricing, insurance tie-ups, and flexible EMI options that keep quality treatment stress-free.",
      icon: Icon5,
    }
  ]
};

const consultationData = {
  title: "When To Consult a Doctor for Cancer-Related Symptoms?",
  items: [
    {
      title: "Unexplained Lump or Swelling",
      description: "Any new lump or swelling in the breast, neck, underarm, or elsewhere that doesn't go away should be evaluated by a specialist without delay.",
      image: "/images/specialities-images/JNK/unexplained-lump-or-swelling.webp",
    },
    {
      title: "Unexplained Weight Loss",
      description: "Sudden or unexplained weight loss without changes in diet or exercise can be an early warning sign of an underlying malignancy.",
      image: "/images/specialities-images/JNK/unexplained-weight-loss.webp",
    },
    {
      title: "Persistent Fatigue",
      description: "Ongoing, unexplained tiredness that doesn't improve with rest may indicate an underlying health issue requiring medical evaluation.",
      image: "/images/specialities-images/JNK/persistent-fatigue.webp",
    },
    {
      title: "Changes in Skin or Moles",
      description: "New growths, or changes in the size, shape, or colour of an existing mole, should be examined promptly by a specialist.",
      image: "/images/specialities-images/JNK/changes-in-skin-or-moles.webp",
    },
    {
      title: "Persistent Cough or Hoarseness",
      description: "A cough or hoarseness lasting more than a few weeks, especially if accompanied by blood, requires prompt medical assessment.",
      image: "/images/specialities-images/JNK/persistent-cough-or-hoarseness.webp",
    },
    {
      title: "Abnormal Bleeding or Discharge",
      description: "Unusual bleeding or discharge, including between periods or after menopause, should never be ignored and warrants immediate consultation.",
      image: "/images/specialities-images/JNK/abnormal-bleeding-or-discharge.webp",
    }
  ]
};

const ConditionsTreatData = {
  title: "Conditions We Treat",
  items: [
    {
      title: "Breast Cancer",
      icon: ConditionIcon1,
    },
    {
      title: "Lung Cancer",
      icon: ConditionIcon2,
    },
    {
      title: "Colorectal Cancer",
      icon: ConditionIcon3,
    },
    {
      title: "Oral & Head-Neck Cancer",
      icon: ConditionIcon4,
    },
    {
      title: "Gastric (Stomach) Cancer",
      icon: ConditionIcon5,
    },
    {
      title: "Gynecological Cancers",
      icon: ConditionIcon6,
    },
    {
      title: "Prostate Cancer",
      icon: ConditionIcon7,
    },
    {
      title: "Blood Cancers (Leukemia/Lymphoma)",
      icon: ConditionIcon8,
    },
    {
      title: "Liver & Pancreatic Cancer",
      icon: ConditionIcon9,
    },
    {
      title: "Bone & Soft Tissue Sarcomas",
      icon: ConditionIcon10,
    },
    {
      title: "Thyroid Cancer",
      icon: ConditionIcon11,
    },
    {
      title: "Skin Cancer (Melanoma & Non-Melanoma)",
      icon: ConditionIcon12,
    }
  ]
};

const faqs = [
  {
    question: "Is chemotherapy painful, and what are its side effects?",
    answer: "Chemotherapy itself is administered through an IV or in tablet form and is not painful during infusion. However, it can cause side effects such as nausea, fatigue, hair loss, and lowered immunity, which vary from person to person depending on the drug protocol and dosage. Our oncology team closely monitors patients throughout treatment and provides supportive care to manage these side effects effectively.",
  },
  {
    question: "How is cancer staged, and why does it matter for treatment?",
    answer: "Cancer staging describes the size of the tumor and how far it has spread, typically ranging from Stage 0 (localized) to Stage IV (advanced/metastatic). Staging is determined through imaging, biopsy, and lab tests, and it directly guides treatment decisions , including whether surgery, chemotherapy, radiation, or a combination is most appropriate, as well as the overall treatment goal and prognosis.",
  },
  {
    question: "Is cancer treatment covered under insurance?",
    answer: "Most major health insurance policies cover cancer treatment, including surgery, chemotherapy, and radiation therapy, though coverage depends on your specific policy and sum insured. At Lokmanya Hospitals, we assist patients with cashless insurance processing and offer flexible EMI options to ease the financial burden of treatment.",
  },
  {
    question: "How long does recovery take after cancer surgery?",
    answer: "Recovery time depends on the type and extent of surgery, the patient's overall health, and whether further treatment like chemotherapy or radiation is needed. Minimally invasive procedures generally allow for a shorter hospital stay and faster return to daily activities compared to open surgery. Our team provides a personalized recovery timeline and follow-up schedule for every patient.",
  }
];
function SpineBack() {

  const router = useRouter();
  const slug = router.pathname;
  const [doctorData, setData] = useState([]);
  useEffect(() => {
    if (!slug || slug.length === 0) return;

    const fullSlug = (Array.isArray(slug) ? slug.join('/') : slug).replace(/^\/+/, '');
    const fetchDoctors = async () => {
      try {
        const response = await getSpecialityDoctors(fullSlug);
        if (!response?.data || response.data.length === 0) {
          return;
        }

        setData(response.data); // set fetched data
      } catch (error) {
        console.error("Failed to fetch doctors:", error);
      }
    };

    fetchDoctors();
  }, [slug]);

  return (
    <>
      <Head>
        <title>Oncology Hospital In Pune | Lokmanya Hospitals</title>
        <meta name="description" content="Oncology hospital in Pune—Lokmanya Hospital." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Hospital",
            "name": "Lokmanya Hospital",
            "url": "https://www.lokmanyahospitals.com/joint-hip-and-knee-replacement",
            "description": "Lokmanya Hospital specializes in advanced joint, hip, and knee replacement surgeries, offering state-of-the-art robotic-assisted procedures and comprehensive orthopedic care in Pune, Maharashtra.",
            "medicalSpecialty": "Joint, Hip, and Knee Replacement",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "402/A Gokhale Nagar Road, Vetal Baba Chowk, off Senapati Bapat, Pune, Maharashtra 411016",
              "addressLocality": "Pune",
              "addressRegion": "Maharashtra",
              "postalCode": "411016",
              "addressCountry": "IN"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-72-1934-3223",
              "contactType": "Customer Service",
              "email": "appointment@lokmanyahospitals.in"
            }
          })}
        </script>
      </Head>
      <div>
        <section>
          <CommonBanner bgColor={"#EFEDD1"} bgImage={kneeImage.src}>
            <div className="header-section">
              <h1 className="page-heading">ONCOLOGY</h1>
              <p className="subtitle">
                Lokmanya Hospitals is renowned for its skilled and experienced team of oncologists who utilize advanced, evidence-based technology for cancer treatment. We prioritize patient comfort and precision care, combining surgical, medical, and radiation oncology under one roof to give every patient the best possible chance at recovery.
              </p>
            </div>
          </CommonBanner>
          <div className="overview-section side-space section-space">
            <h2 className="page-heading">Overview</h2>
            <div className="para">
              <p >
                Lokmanya Hospitals is a trusted name for cancer treatment in Pune, offering a complete range of oncology care solutions designed to address malignancies at every stage. Our dedicated oncology department is equipped with state-of-the-art diagnostic and treatment technology, supported by a team of expert oncologists, cancer surgeons, and radiation specialists.
              </p>
              <p >
                From early cancer screening and biopsy to complex tumor surgery, chemotherapy, and radiation therapy, we offer comprehensive, individualized treatment plans. Whether you require surgical oncology, medical oncology, or a combined multidisciplinary approach, our specialists guide you through every step of your diagnosis, treatment, and recovery journey.
              </p>
            </div>
          </div>
        </section>
        <WhyChooseSection data={WhyChooseData} />
        <OurServicesSection data={serviceData} />
        {doctorData && doctorData.length > 0 && (
          <MeetOurExpertSpeciality data={doctorData} />
        )}
        <WhatsetsApartSection data={whatsetsApartdata} />
        <WhenConsultSection data={consultationData} />
        <ConditionsTreatSection data={ConditionsTreatData} />
        <FaqSection data={faqs} />
        <PatientSuccessStories />
        <LokmanyaNetwork />
      </div>
    </>
  )
}

export default SpineBack 
